// Position fuer v-select mit append-to-body: Die Liste ist global mindestens 300 px breit (_select.scss) und ragt in
// schmalen Filterspalten rechts aus dem Bild (Trello 3b9GL2pS, Update P). Passt sie nicht, wird sie rechtsbuendig am Feld ausgerichtet.
export function alignDropdown(dropdownList, component, { width, top, left }) {
  const rect = component.$el.getBoundingClientRect();
  dropdownList.style.top = top;
  dropdownList.style.width = width;
  const listWidth = Math.max(dropdownList.offsetWidth, rect.width);
  const fits = rect.left + listWidth <= window.innerWidth - 8;
  dropdownList.style.left = fits ? left : `${Math.max(8, rect.right - listWidth) + window.scrollX}px`;
}
